import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Cargando...</div>;
}

const SalesContainer = Loadable({
    loader: () => import('../../Containers/Report/SalesContainer'),
    loading: Loading,
});

const ProfitsContainer = Loadable({
    loader: () => import('../../Containers/Report/ProfitsContainer'),
    loading: Loading,
});

const reportRoutes = [
    { path: '/report/sales', name: 'Reporte de ventas', exact: true, component: SalesContainer },
    { path: '/report/profits', name: 'Reporte de utilidades', exact: true, component: ProfitsContainer },
];

export default reportRoutes;


// WEBPACK FOOTER //
// ./src/Routes/Modules/reports.js